import { DesignModel, syncEntityModel } from '@msdk/definitions'
import { selectorFamily } from 'recoil'

import { IndexedDb } from '../../utils'
import { $tenant } from '../auth'
import { $baseMetadataByEntity } from '../base-metadata'
import { $apiClient } from '../core'

export const $model = selectorFamily({
  key: 'MetadataModel',
  get:
    (msName: string) =>
    async ({ get }) => {
      if (!msName) return new DesignModel()
      const tenant = get($tenant)
      const client = get($apiClient)
      const db = new IndexedDb(tenant)
      let cachedModel = await db.readMetadata(msName)
      const cachedVersion = (cachedModel?.version ?? '') as string
      const result = await client.metadata.getVersionedModel(msName, cachedVersion)

      if (!!result && result.version !== cachedVersion) {
        cachedModel = { version: result.version, model: result.model }
        await db.saveMetadata(msName, cachedModel)
      }

      const model = new DesignModel()
      model.merge(cachedModel?.model as DesignModel, msName)
      // sync with local storage
      await syncEntityModel(cachedModel?.model as DesignModel, msName)
      return model
    },
})

export const $entityModel = selectorFamily({
  key: 'EntityModel',
  get:
    (entityName: string) =>
    ({ get }) => {
      const baseMetadata = get($baseMetadataByEntity(entityName))
      const model = get($model(baseMetadata?.msProvider as string))
      return model.getEntity(entityName)
    },
})
